
import React, { Component } from 'react';
import './add-student.scss'
import { Modal, ModalBody } from "reactstrap";
import SchoolUserApi from '../../../apis/student'
import Dropdown from '../../common/dropdown-v2/dropdown';
import CommonApi from '../../../apis/common'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';
import SchoolApi from '../../../apis/school';
const GENDER = [{title: "Male", value: "M"}, {title: "Female", value: "F"}]
class AddStudentComponent extends Component {

    state = {
        contactDetails: [{ countryCode: "+91" }],
        disableAddButton: true
    }

    constructor(props) {
        super(props)
        this.state.class = this.props.selectedClass?.class;
        this.state.board = this.props.selectedClass?.board;
        this.state.section = this.props.selectedClass?.section;
        this.state.sectionId = this.props.selectedClass?._id;

        if (this.props.mode === 'EDIT') {
            this.state.disableAddButton = false
            this.state.name = this.props.selectedUser.name;
            this.state.email = this.props.selectedUser.email;
            this.state.rollNumber = this.props.selectedUser.rollNumber
            this.state.gender = this.props.selectedUser.gender
            this.state.class = this.props.selectedUser?.class;
            this.state.board = this.props.selectedUser?.board;
            this.state.section = this.props.selectedUser?.section;
            this.state.sectionId = this.props.selectedUser?.sectionId;
            this.state.previousYearMark = this.props.selectedUser?.previousYearMark?.mark;
            this.state.contactDetails = this.props.selectedUser?.contactDetails || [{}];
            if(this.state.class) this.getSections({class: this.state.class, board: this.state.board})
        }

    }
    countryCodeHash = {}

    blongsToDropDown = [{ title: "SELF", value: "SELF" }, { title: "PARENT", value: "PARENT" }, { title: "OTHER", value: "OTHER" },]

    componentDidMount() {
        this.getCountryCodes();
        if(!this.props.selectedClass) {
            this.getClassAndBoard()
        }
    }

    getCountryCodes(payload = {}) {

        CommonApi.getCountryCode(payload).then(response => {
            let data = response.response
            if (data.length) {
                this.setState({ countryList: data })
                let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                this.setState({ countryCodeDropdown })
            }
        }).catch(err => {
        })

    }

    getClassAndBoard(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                let board = this.state.board
                if (!board && boards.length == 1) {
                    board = boards[0].value
                }


                this.setState({ board, classes: classes, boards: boards })
            }).catch(err => {
            })
    }


    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.class
        if (!payload.board) payload.board = this.state.board

        SchoolApi.getSections(payload)
        
            .then(response => {
                let sections = response.response
                let arr = []
                for (let i = 0; i < sections.length; i++) {
                    let section = sections[i]
                    arr.push({
                        title: section.section,
                        value: section._id,
                    })
                }
                let classDetails = {
                    class: this.state.class,
                    board: this.state.board
                }
                this.setState({ sections: arr, sectionLoaded: true },)
            }).catch(err => {
                this.setState({ sections: [], section: "" })
            })
    }


    onSelectClass = (option) => {
        if(!option){
            this.setState({class: "", sections: []});
            return;
        }
        this.selectedClass = this.state.classes.filter(item => item.value == option)[0]

        this.setState({ class: option.value, sectionLoaded: false }, () => {
            if(this.state.class && this.state.board) this.getSections()
        })
    }

    onSelectBoard = (option) => {
        if(!option){
            this.setState({class: ""});
            return;
        }
        this.setState({ board: option.value, sectionLoaded: false }, () => {
            if(this.state.class && this.state.board) this.getSections()
        })
    }

    onSelectSection = (option) => {
        if(!option){
            this.setState({class: ""});
            return;
        }
        this.setState({ section: option?.title, sectionId: option?.value, reload: true }, () => {
            this.setState({ reload: false })
        })
    }

    onSelectType = (option) => {
        let types = option.map(item => ({ type: item.value }))
        this.setState({ types })
    }

    onCountryCodeSearch(value) {
        if (value.length > 2 || !value) {
            this.getCountryCodes({ name: `/${value}`, })
        }
    }

    onSelectCountryCode(option, index) {
        let contactDetails = this.state.contactDetails
        contactDetails[index]["countryCode"] = option?.value
        this.setState({ contactDetails, showDropdownIndex: "" })
    }


    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = [];
        let localHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]

            if (!localHash[item.dialCode]) {
                this.countryCodeHash[item.dialCode] = item
                localHash[item.dialCode] = item
                countryCodeDropdown.push({ title: `${item.dialCode}`, addOn: item.name, value: item.dialCode })
            }
        }
        return countryCodeDropdown
    }

    onSelectGender = (option) => {
        this.setState({ gender: option?.value }, () => {
            this.localValidation()
        })
    }

    onChangeHandler = (event, key, type) => {
        if (type == "mobileNumber" && !this.state[key]) {
            if (!CommonUtils.isAllowMobileNumber(event.target.value)) {
                let stateValue = this.state[key]
                this.setState({ [key]: "" }, () => {
                    this.setState({ [key]: stateValue }, () => {
                        this.localValidation()
                    })
                })
                return
            }
        }
        this.setState({ [key]: event.target.value }, () => {
            this.localValidation()
        })
    }

    onContactChangeHandler = (event, index, key, type) => {
        if (type == "mobileNumber" && !this.state.contactDetails[index][key]) {
            if (!CommonUtils.isAllowMobileNumber(event.target.value)) {
                let stateValue = this.state[key]
                this.setState({ [key]: "" }, () => {
                    this.setState({ [key]: stateValue }, () => {
                        this.localValidation()
                    })
                })
                return
            }
        }
        let contactDetails = this.state.contactDetails
        contactDetails[index][key] = event.target.value
        this.setState({ contactDetails }, () => {
            this.localValidation()
        })
    }


    onSelectDropDown = (option, index, key) => {
        let contactDetails = this.state.contactDetails
        contactDetails[index][key] = option?.value
        this.setState({ contactDetails }, () => {
            this.localValidation()
        })
    }


    addContact = () => {
        let contactDetails = this.state.contactDetails
        contactDetails.push({ countryCode: "+91" })
        this.setState({ contactDetails })
    }

    onSave() {

        if (this.state.isSaving) return
        this.setState({ isSubmit: true })

        let payload = this.buildPayload()
        if (!this.validatePayload(payload)) return

        this.setState({ isSaving: true })

        if (this.props.mode === 'EDIT') {
            payload._id = this.props.selectedUser?._id
            SchoolUserApi.updateSchoolUser(payload).then(response => {
                this.props.onSave()
                this.setState({ isSubmit: false, isSaving: false })
            }).catch(err => {
                this.setState({ isSubmit: false, isSaving: false })
            })
        } else {
            SchoolUserApi.addSchoolUser(payload).then(response => {
                this.props.onSave(1)
                this.setState({ isSubmit: false, isSaving: false })
            }).catch(err => {
                this.setState({ isSubmit: false, isSaving: false })
            })
        }

    }

    buildPayload() {
        return {
            class: this.state?.class,
            board: this.state?.board,
            section: this.state?.section,
            sectionId: this.state?.sectionId,
            name: this.state.name,
            rollNumber: this.state.rollNumber,
            gender: this.state.gender,
            previousYearMark: this.state.previousYearMark,
            contactDetails: this.state.contactDetails
        }

    }
    localValidation() {
        let payload = this.buildPayload()
        let validate = this.validatePayload(payload, true)
        this.setState({ disableAddButton: !validate })
    }

    validatePayload(payload = {}, dontShowErrorMessage = false) {
        if (!payload.board) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Board is required" })
            return false
        }

        if (!payload.class) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Class is required" })
            return false
        }

        // if (!payload.section) {
        //     if (!dontShowErrorMessage) this.setState({ errorMessage: "Section is required" })
        //     return false
        // }

        if (!payload.name) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please enter name" })
            return false
        }

        if (!payload.gender) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please select gender" })
            return false
        }

        if (!payload.contactDetails?.length) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please add atleat a contact details" })
            return false
        }

        if (payload.contactDetails?.length) {
            let validation = false
            for (let i = 0; i < payload.contactDetails?.length; i++) {
                let contact = payload.contactDetails[i]

                if (!contact.mobileNumber && !contact.email && !validation) {
                    if (!dontShowErrorMessage) this.setState({ errorMessage: "Please add email or mobile number" })
                } else {
                    validation = true
                }

                if (contact.mobileNumber && contact.countryCode) {
                    if (!CommonUtils.validateMobileNumber(contact.mobileNumber, this.countryCodeHash[contact.countryCode])) {
                        if (!dontShowErrorMessage) this.setState({ errorMessage: "invalid mobile number" })
                        validation = false
                    }
                }

                if (contact.email) {
                    if (!CommonUtils.validateEmail(contact.email)) {
                        if (!dontShowErrorMessage) this.setState({ errorMessage: "invalid email id" })
                        validation = false
                    }

                }

                if (contact.email && !this.validateEmail(contact.email) && !dontShowErrorMessage) {
                    contact.isInvalidEmail = true
                } else {
                    contact.isInvalidEmail = false
                }

                if (!contact.type) {
                    if (!dontShowErrorMessage) this.setState({ errorMessage: "Please select belongs to" })
                    return false
                }
            }
            if (!validation) {
                return false
            }
        }

        this.setState({ errorMessage: "", contactDetails: payload.contactDetails })
        return true
    }

    validateEmail(value) {
        if (value) {
            let isValid = CommonUtils.validateEmail(value);
            if (!isValid) {
                this.setState({ isInvalidEmail: true });
                return false
            }
            else {
                this.setState({ isInvalidEmail: false })
                return true
            }
        } else {
            this.setState({ isInvalidEmail: true });
            return false
        }
    }


    openCountryCode(index) {
        this.setState({ showDropdownIndex: index })
    }

    removeContactDetail = (index) => {
        let contactDetails = this.state.contactDetails
        contactDetails.splice(index, 1);
        if (!contactDetails.length) {
            contactDetails.push({ countryCode: "+91" })
        }
        this.setState({ contactDetails, reload: true }, () => {
            this.setState({ reload: false }, () => {
                this.localValidation()
            })
        })
    }

    countryCodeDropDown(dropDownList = [], index) {
        return (
            <div className="country-code-drop-down" id="st-3">
                <div className="p-2">
                    <div className="search">
                        <input className="form-control" placeholder={`Search`} value={this.state.search} onChange={(event) => { this.onCountryCodeSearch(event.target.value) }} />
                    </div>
                    <div>
                        {dropDownList.length ?
                            dropDownList.map(dropdown => (
                                <div className="dropdown-list cursor-pointer px-3 py-1" onClick={() => { this.onSelectCountryCode(dropdown, index) }}>
                                    <div className="row country-name cursor-pointer">
                                        <div className="col-8"> {dropdown.addOn}</div>
                                        <div className="col text-right"> {dropdown.title}</div>
                                    </div>
                                </div>

                            ))
                            : <div className="text-center py-4 no-data">
                                <label> No Records found</label>
                            </div>
                        }</div>
                </div>
            </div>
        )
    }

    showSetupSection = _ => {
        this.props.showSetupSection(this.state.board, this.state.class)
    }

    render() {
        const {sectionLoaded} = this.state
        return (
            <div className="add-student">
                <div className='bw-spaces-input pt-3'>
                    <div className='row '>
                        {this.state.boards?.length > 1 && 
                            <div className='col-4'>
                                <label className='cw-input-label'>Board</label>
                                <Dropdown
                                    placeholder='Select'
                                    options={this.state.boards}
                                    onSelect={(option) => this.onSelectBoard(option)}
                                    text={"title"}
                                    value={this.state.board}
                                    style={{ backgroundColor: "#F6F7F5" }}
                                    invalid={this.state.isSubmit && !this.state.board}
                                />
                            </div>
                        }
                        {this.state.classes?.length > 0 && 
                            <div className='col-4'>
                                <label className='cw-input-label'>Class</label>
                                <Dropdown
                                    placeholder='Select'
                                    options={this.state.classes}
                                    onSelect={(option) => this.onSelectClass(option)}
                                    text={"title"}
                                    value={this.state.class}
                                    style={{ backgroundColor: "#F6F7F5" }}
                                    invalid={this.state.isSubmit && !this.state.class}
                                />
                            </div>
                        }
                        {this.state.sections?.length > 0 && sectionLoaded && this.state.sections[0]?.title !== 'No Sections' &&
                            <div className='col-4'>
                                <label className='cw-input-label'>Section</label>
                                <Dropdown
                                    placeholder='Select'
                                    options={this.state.sections}
                                    onSelect={(option) => this.onSelectSection(option)}
                                    text={"title"}
                                    value={this.state.sectionId}
                                    style={{ backgroundColor: "#F6F7F5" }}
                                    invalid={this.state.isSubmit && !this.state.sectionId}
                                />
                            </div>
                        }
                        {!this.state.sections?.length && sectionLoaded && 
                            <div className='col-4 cursor-pointer add-section-container' onClick={this.showSetupSection}>
                                <img className="custom-add-icon mr-2" onClick={this.addNewContact} src={getImageSource(ImageConstants.ADD)} />
                                <span className='add-section-text'>ADD SECTION</span>
                            </div>
                        }
                    </div>
                </div>
                <div className='bw-spaces-input pt-3'>
                    <div className='row '>
                        <div className='col'>
                            <div className='cw-input-label'>NAME <span className='star'>*</span></div>
                            <input className={`cw-input ${this.state.isSubmit && !this.state.name ? "invalid" : ""}`} placeholder='Enter First Name'
                                value={this.state.name}
                                onChange={(e) => this.onChangeHandler(e, 'name')} />
                        </div>

                        <div className="col">
                            <div className='cw-input-label'>ROLL NO.</div>
                            <input className={`cw-input`} placeholder='Enter Roll No.'
                                value={this.state.rollNumber}
                                onChange={(e) => this.onChangeHandler(e, 'rollNumber')} />
                        </div>

                        

                    </div>
                </div>
                <div className='bw-spaces-input pt-3'>
                    <div className='row '>
                        <div className='col'>
                            <label className='cw-input-label'>Gender</label>
                            <Dropdown
                                placeholder='Select Gender'
                                options={GENDER}
                                onSelect={(option) => this.onSelectGender(option)}
                                text={"title"}
                                value={this.state.gender}
                                style={{ backgroundColor: "#F6F7F5" }}
                                invalid={this.state.isSubmit && !this.state.gender}
                            />
                        </div>
                        <div className="col">
                            <div className='cw-input-label'>PREVIOUS YEAR MARKS</div>
                            <input type="number" min={0} className={`cw-input`} placeholder='Enter Previous Year Marks'
                                value={this.state.previousYearMark}
                                onChange={(e) => this.onChangeHandler(e, 'previousYearMark')} />
                        </div>
                    </div>
                </div>
                <div className='row bw-spaces-input'>
                    <div className='col'>
                        <div>
                            <label className='cw-input-label no-padding'>CONTACT DETAILS  <span className="note">(This is required to send the Countingwell App link)</span></label>
                        </div>
                    </div>
                </div>
                {!this.state.reload && this.state.contactDetails?.length ? this.state.contactDetails?.map((item, index) => (
                    < div className='row bw-spaces-input'>

                        <div className='col-4'>
                            <label className='cw-input-label'>MOBILE NUMBER</label>
                            <div className="mobile-number">
                                <span className={`px-2 country-code ${this.state.isOtpSent ? "cursor: default" : "cursor-pointer"}`} onClick={() => this.openCountryCode(index)}>
                                    <strong> {item.countryCode} </strong>
                                </span>
                                <input className={`cw-input`} placeholder='Enter Mobile No.'
                                    value={item.mobileNumber}
                                    onChange={(e) => this.onContactChangeHandler(e, index, 'mobileNumber', 'mobileNumber')} />
                            </div>

                            <div className="abs-div" onMouseLeave={() => this.openCountryCode()}>
                                {this.state.showDropdownIndex === index ? this.countryCodeDropDown(this.state.countryCodeDropdown, index) : ""}
                            </div>
                        </div>

                        <div className='col-4'>
                            <label className='cw-input-label'>EMAIL ID</label>
                            <input className={`cw-input ${(item.isSubmit && item.email) || item.isInvalidEmail ? "invalid" : ""}`} placeholder='Enter Email Id'
                                value={item.email}
                                onChange={(e) => this.onContactChangeHandler(e, index, 'email')} />
                        </div>

                        <div className='col-3'>
                            <label className='cw-input-label'>BELONGS TO</label>
                            <Dropdown
                                placeholder='Select'
                                options={this.blongsToDropDown}
                                onSelect={(option) => this.onSelectDropDown(option, index, "type")}
                                text={"title"}
                                value={item.type}
                                style={{ backgroundColor: "#F6F7F5" }}
                                invalid={this.state.isSubmit && !item.type}
                            />
                        </div>

                        <div className='col action-container'>
                            <img className="add-student-icn cursor-pointer" onClick={() => this.removeContactDetail(index)} src={getImageSource(ImageConstants.DELETE_RED)} />
                        </div>
                    </div>
                )) : ""}
                <div className="row pt-4">
                    <div className="col-10">
                        <div className="note note-text">NOTE: Phone or Email, Atleast one of the info is mandatory</div>
                    </div>
                    <div className="col text-right my-auto"><span className="add-button" onClick={this.addContact}> + </span></div>
                </div>
                <div className="text-center pt-4">
                    {this.state.errorMessage ? <div className="text-danger pb-4"><strong>{this.state.errorMessage} </strong></div> : ""}
                    <button className={`cw-button-primary ${this.state.disableAddButton ? "disable-button" : ""}`} onClick={() => this.onSave()}>
                        {this.props.buttonName || "Save"}
                    </button>
                </div>
            </div>
        );
    }
}

export default AddStudentComponent;